import { render } from "./LoginSignUp.vue?vue&type=template&id=61134d7a&scoped=true"
import script from "./LoginSignUp.vue?vue&type=script&lang=js"
export * from "./LoginSignUp.vue?vue&type=script&lang=js"

import "./LoginSignUp.vue?vue&type=style&index=0&id=61134d7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61134d7a"]])

export default __exports__